import React from 'react';
import PropTypes from 'prop-types';

import { getArticlePath } from 'dpl/prismic/utils';
import Icon from 'dpl/common/components/Icon';
import SmartImage from 'dpl/components/SmartImage';

export default function CustomLinkInsert({ sliceData }) {
  return (
    <div className="PrismicCustomLinkInsert pv10 pv20-lg bg-lightest-purple tc">
      <div className="container">
        <div className="row">
          <div className="col-lg-8 col-xl-6 center">
            <p className="mb6 fw-medium f4">{sliceData.primary.headline}</p>
            <div className="mb10 ph4 bb b--black bw1 dib" />
            <a
              href={
                sliceData.primary.link.url
                  ? sliceData.primary.link.url
                  : getArticlePath(sliceData.primary.link)
              }
            >
              <div className="aspect-ratio aspect-ratio--6x4 relative overflow-hidden br1">
                <div className="aspect-ratio--object z-0">
                  <SmartImage
                    Tag="div"
                    alt={sliceData.primary.image.alt}
                    className="w-100 h-100 bg-center cover"
                    lazy
                    src={sliceData.primary.image.url}
                  />
                </div>
                <div className="absolute top-0 left-0">
                  <div className="ph6 pv6 relative bg-black white">
                    <Icon className="transform-center-all" name="book" />
                  </div>
                </div>
                <div className="scrim--gradient-black w-100 h-100 absolute top-0 left-0 br1" />
                <div className="w-100 ph10 transform-center-all white">
                  <p className="mb2 f6 fw-medium">
                    {sliceData.primary.image_title}
                  </p>
                  {sliceData.primary.image_subtitle && (
                    <p className="d-none d-lg-block">
                      {sliceData.primary.image_subtitle}
                    </p>
                  )}
                </div>
                <div className="w-100 pv2 pv3-lg absolute bottom-0 bg-black white br1 br--bottom">
                  <p className="inline-flex align-items-center">
                    <span className="mr4 fw-medium">
                      {sliceData.primary.link_text}
                    </span>
                    <Icon name="lined-arrow-right" />
                  </p>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

CustomLinkInsert.propTypes = {
  sliceData: PropTypes.shape({
    primary: PropTypes.shape({
      headline: PropTypes.string,
      link: PropTypes.shape({
        url: PropTypes.string
      }),
      image: PropTypes.shape({
        alt: PropTypes.string,
        url: PropTypes.string
      }),
      image_title: PropTypes.string,
      image_subtitle: PropTypes.string,
      link_text: PropTypes.string
    }).isRequired
  }).isRequired
};
